import { render } from "./GammeProduct.vue?vue&type=template&id=215e31c8&scoped=true"
import script from "./GammeProduct.vue?vue&type=script&lang=js"
export * from "./GammeProduct.vue?vue&type=script&lang=js"

import "./GammeProduct.vue?vue&type=style&index=0&id=215e31c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215e31c8"]])

export default __exports__